module.exports = __webpack_public_path__ + "static/media/icon_184.adc7ee80.svg";